import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { KemyoonLogo } from '@/components/KemyoonLogo'

export function PrivacyPolicyPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 bg-background/95 backdrop-blur border-b z-10">
        <div className="px-3 py-3 flex items-center gap-2">
          <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="font-semibold">Privacy Policy</h1>
        </div>
      </header>

      <div className="max-w-2xl mx-auto px-6 py-8 space-y-6">
        <div className="text-center mb-8">
          <KemyoonLogo size="md" />
          <p className="text-xs text-muted-foreground mt-2">
            Last updated: April 2026
          </p>
        </div>

        <div className="space-y-5 text-sm text-foreground leading-relaxed">
          <section>
            <h2 className="text-base font-semibold mb-2">
              Welcome to kemyoon
            </h2>
            <p>
              kemyoon is a barangay information management system designed to
              connect Filipino communities. This Privacy Policy explains how we
              collect, use, and protect your personal information.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">
              Information We Collect
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>
                <strong>Account info:</strong> username, password (encrypted),
                and mobile number
              </li>
              <li>
                <strong>Profile info:</strong> name, address, demographic
                details you provide
              </li>
              <li>
                <strong>Usage data:</strong> messages, announcements you've
                read, app interactions
              </li>
              <li>
                <strong>Location data:</strong> only when you actively use SOS
                or location-based services
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">
              How We Use Your Information
            </h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>To provide barangay services and verification</li>
              <li>To enable resident-to-resident communication</li>
              <li>
                To deliver community announcements relevant to your barangay
              </li>
              <li>To respond to emergencies via the SOS feature</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">
              Information Sharing
            </h2>
            <p>
              We do not sell your personal information. Your data is shared only
              with:
            </p>
            <ul className="list-disc pl-5 space-y-1 mt-1">
              <li>
                Your barangay officials for verification and service delivery
              </li>
              <li>
                Other residents you choose to chat with (only your username)
              </li>
              <li>Emergency responders during active SOS incidents</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">Your Rights</h2>
            <p>
              You have the right to access, correct, or delete your personal
              information. Contact your barangay admin or kemyoon support to
              exercise these rights.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">Data Security</h2>
            <p>
              We use industry-standard encryption to protect your data. Passwords
              are hashed using bcrypt and never stored in plain text.
            </p>
          </section>

          <section>
            <h2 className="text-base font-semibold mb-2">Contact</h2>
            <p>
              For questions about this Privacy Policy, contact your barangay or
              email support@kemyoon.ph (placeholder).
            </p>
          </section>

          <div className="mt-8 p-4 bg-muted rounded-lg text-xs text-muted-foreground">
            <strong>Note:</strong> This is a placeholder Privacy Policy for
            development. A final version compliant with the Philippines Data
            Privacy Act (RA 10173) will be published before public release.
          </div>
        </div>
      </div>
    </div>
  )
}
